import React from 'react';

import {useAccountEntityTypes} from 'src/hooks/dictionaries';

import {ComboBox, ComboboxItem} from '@pb/kit-component-combo-box';
import Label from '@pb/kit-component-label';


type Props = {
    onSelect: (entityType: string) => void,
    selectedEntityType?: string,
};

export const AccountEntityTypeFilter = ({onSelect, selectedEntityType}: Props) => {
    const {accountEntityTypes} = useAccountEntityTypes();

    return (
        <div style={{width: 300}}>
            <Label>Entity Type</Label>
            <ComboBox
                placeholder="Select entity type"
                value={selectedEntityType}
                onChange={onSelect}>
                {accountEntityTypes.map(({code, description}) => (
                    <ComboboxItem key={code} caption={description} value={code}/>
                ))}
            </ComboBox>
        </div>
    );
};
